var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"riseup-header"},[_c('div',{staticClass:"right-nav"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('@/assets/riseup-logo.svg')}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d6ec92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/app-header/RiseupHeader.vue
// module id = null
// module chunks = 